import React, { createContext, useContext, useEffect, useState } from "react";
import { applyTheme } from "@/lib/themes";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => localStorage.getItem("sofi_theme") || "oceano");
  const [dark, setDarkState] = useState(() => localStorage.getItem("sofi_dark") === "true");

  useEffect(() => {
    const el = document.documentElement;
    if (dark) el.classList.add("dark");
    else el.classList.remove("dark");
    applyTheme(theme, dark);
    localStorage.setItem("sofi_theme", theme);
    localStorage.setItem("sofi_dark", String(dark));
  }, [theme, dark]);

  const setTheme = (t) => setThemeState(t);
  const setDark = (val) => setDarkState((prev) => (typeof val === "function" ? val(prev) : val));

  return (
    <ThemeContext.Provider value={{ theme, setTheme, dark, setDark }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
